import styled from 'styled-components'
import {
  OPPORTUNITY_FORM_COVER_ASPECT_RATIO,
  OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH,
} from '../opportunityCoverDimensions'
import { Button, Form } from 'react-bootstrap'

export const OpportunityFormWrapper = styled.div`
  height: fit-content;

  .form-label {
    color: #464646 !important;
    font-weight: 600 !important;
  }

  .required-mark,
  .text-danger {
    color: #dc3545 !important;
  }
`

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  gap: 16px;
  flex-wrap: wrap;
`

export const FormTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
`

export const CardSection = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px 0 #00000014;
  padding: 24px;
  margin-bottom: 32px;
  color: #464646;
`

export const FieldGroup = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  label,
  .form-label {
    color: #464646;
    font-weight: 600;
  }

  .required-mark,
  .text-danger,
  label .required-mark {
    color: #dc3545 !important;
  }
`

export const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #464646;
  margin-bottom: 6px;
  display: block;
`

export const HelperText = styled.p`
  font-size: 0.75rem;
  color: #667085;
  margin: 0 0 8px;
  line-height: 1.4;
`

export const ImageNoteText = styled.small`
  font-size: 0.72rem;
  color: #888;
  display: block;
  margin-bottom: 10px;
`

export const SectionLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
`

export const ImagesUploadRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`

export const ImagePreviewWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: ${OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH}px;
  max-width: 100%;
  aspect-ratio: ${OPPORTUNITY_FORM_COVER_ASPECT_RATIO};
  flex-shrink: 0;
`

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  display: block;
`

export const ImagePreviewRemoveButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #0d6efd;
  border: 2px solid white;
  color: white;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 0;
  line-height: 1;

  &:hover {
    background-color: #0b5ed7;
  }
`

export const DescriptionCharCount = styled.p`
  font-size: 0.875rem;
  color: #667085;
  margin: 4px 0 0;
  text-align: right;
`

export const RequiredMark = styled.span`
  color: #dc3545 !important;
  margin-left: 2px;
`

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .form-check-label {
    font-size: 0.875rem;
    color: #464646;
    font-weight: 500;
  }
`

export const CheckboxItem = styled(Form.Check)`
  margin-bottom: 0;
`

export const UploadBtn = styled(Button)`
  background: #a0d6ff;
  border: 1px solid #a0d6ff;
  color: #01579e;
  font-size: 0.875rem;
  font-weight: 750;
  border-radius: 4px;
  &:hover,
  &:focus {
    background: #1b66c6;
    border-color: #185ab0;
    color: #fff;
  }
`

export const SupportMaterialsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
`

export const FileItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #00599c;
  font-size: 0.875rem;
`

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #666;
  }
`

export const SaveButton = styled(Button)<{ $disabled?: boolean }>`
  && {
    background-color: ${({ $disabled }) => ($disabled ? '#C4C5C6' : '#00599c')};
    border-color: ${({ $disabled }) => ($disabled ? '#C4C5C6' : '#00599c')};
    color: #fff;
    font-family: 'Caixa Std', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.4;
    padding: 6px 16px;
    border-radius: 4px;
    height: 32px;
    min-height: 32px;
    min-width: 120px;
    white-space: nowrap;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  }

  &&:hover,
  &&:focus {
    background-color: ${({ $disabled }) => ($disabled ? '#C4C5C6' : '#004377')};
    border-color: ${({ $disabled }) => ($disabled ? '#C4C5C6' : '#004377')};
    color: #fff;
  }
`
